import React from "react";

// Draw multiple concentric radial progress arcs
// values: array of { value: number (0-100), color: string }
export const MultiRingProgress = ({
  values = [],
  size = 96,
  stroke = 8,
  gap = 6, // gap between rings
  bgColor = "#E5E7EB", // gray-200
  ariaLabel = "Average feedback",
}) => {
  const rings = values.slice(0, 4); // at most 4 rings
  const center = size / 2;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      role="img"
      aria-label={ariaLabel}
    >
      {rings.map((ring, idx) => {
        const radius = (size - stroke) / 2 - idx * (stroke + gap);
        if (radius <= 0) return null;
        const circumference = 2 * Math.PI * radius;
        const clamped = Math.max(0, Math.min(100, Number(ring.value) || 0));
        const offset = circumference - (clamped / 100) * circumference;
        return (
          <g key={idx}>
            <circle
              cx={center}
              cy={center}
              r={radius}
              stroke={bgColor}
              strokeWidth={stroke}
              fill="transparent"
            />
            <circle
              cx={center}
              cy={center}
              r={radius}
              stroke={ring.color}
              strokeWidth={stroke}
              fill="transparent"
              strokeDasharray={circumference}
              strokeDashoffset={offset}
              strokeLinecap="butt"
              transform={`rotate(-90 ${center} ${center})`}
            />
          </g>
        );
      })}
    </svg>
  );
};

export default MultiRingProgress;
